var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoveredParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 19.4688H34.9375",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 27.7188V30.8125C32.875 31.086 32.7664 31.3483 32.573 31.5417C32.3796 31.7351 32.1173 31.8438 31.8438 31.8438H28.75C28.4765 31.8438 28.2142 31.7351 28.0208 31.5417C27.8274 31.3483 27.7188 31.086 27.7188 30.8125V27.7188",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 27.7188V30.8125C13.2812 31.086 13.1726 31.3483 12.9792 31.5417C12.7858 31.7351 12.5235 31.8438 12.25 31.8438H9.15625C8.88275 31.8438 8.62044 31.7351 8.42705 31.5417C8.23365 31.3483 8.125 31.086 8.125 30.8125V27.7188",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 23.5938H14.3125",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6875 23.5938H28.75",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.875 19.4688L29.0207 10.8062C28.9407 10.623 28.8092 10.4669 28.6421 10.3571C28.475 10.2472 28.2796 10.1883 28.0797 10.1875H12.9203C12.7204 10.1883 12.525 10.2472 12.3579 10.3571C12.1908 10.4669 12.0593 10.623 11.9793 10.8062L8.125 19.4688V27.7188H32.875V19.4688Z",
    stroke: "#2A3842",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.82422,
    y: 4,
    width: 30.525,
    height: 1.65,
    rx: 0.825,
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoveredParking);
export default __webpack_public_path__ + "static/media/coveredParking.6604146ab2fb1ec74521d0cc3b551381.svg";
export { ForwardRef as ReactComponent };